<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {

		}
	}
</script>

<style lang="scss">
	@import "./assets/scss/style.scss";
	@import "@/assets/scss/base";
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
    background: #f2f2f2;
	}
	img{
		max-width: 100%;
	}
</style>
